/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mellow_Pretty_Rat_EarnInputs */

const es_mellow_pretty_rat_earn = /** @type {(inputs: Mellow_Pretty_Rat_EarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quiero recibir novedades y ofertas de Zarpar`)
};

const gl_mellow_pretty_rat_earn = /** @type {(inputs: Mellow_Pretty_Rat_EarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quero subscribirme ao boletín informativo de Zarpar`)
};

const en_mellow_pretty_rat_earn = /** @type {(inputs: Mellow_Pretty_Rat_EarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I want to subscribe to Zarpar's newsletter`)
};

/**
* | output |
* | --- |
* | "I want to subscribe to Zarpar's newsletter" |
*
* @param {Mellow_Pretty_Rat_EarnInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const mellow_pretty_rat_earn = /** @type {((inputs?: Mellow_Pretty_Rat_EarnInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mellow_Pretty_Rat_EarnInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_mellow_pretty_rat_earn(inputs)
	if (locale === "en") return en_mellow_pretty_rat_earn(inputs)
	return es_mellow_pretty_rat_earn(inputs)
});